import React from 'react';
import TooltipSystemV2 from '../TooltipSystemV2';
import moment from 'moment';

/**
 * Checks if a date is within the specified range
 * @param {Object} date - The date to check (Ant Design date object)
 * @param {Date} minDate - The minimum date of the range
 * @param {Date} maxDate - The maximum date of the range
 * @returns {boolean} - True if the date is outside the range, false otherwise
 */
export const isDateInRange = (date, minDate, maxDate) => {
  if (!date) {
    return false;
  }

  const normalizedDate = moment(date).startOf('day');
  const normalizedMinDate = minDate ? moment(minDate).startOf('day') : null;
  const normalizedMaxDate = maxDate ? moment(maxDate).startOf('day') : null;

  if (normalizedMinDate && normalizedMaxDate) {
    return (
      normalizedDate.isSameOrAfter(normalizedMinDate) &&
      normalizedDate.isSameOrBefore(normalizedMaxDate)
    );
  }

  if (normalizedMinDate) {
    return normalizedDate.isSameOrAfter(normalizedMinDate);
  }

  if (normalizedMaxDate) {
    return normalizedDate.isSameOrBefore(normalizedMaxDate);
  }

  return true;
};

/**
 * Custom render function for calendar dates
 * Adds tooltip for disabled dates
 * @param {Object} current - The current date being rendered (Ant Design date object)
 * @param {Date} minDate - The minimum date of the range
 * @param {Date} maxDate - The maximum date of the range
 * @returns {ReactNode} - The rendered date cell
 */
export const dateRender = ({
  current,
  minDate,
  maxDate,
  unavailableDateTooltip,
  availableDateTooltip
}) => {
  const UNAVAILABLE_DATE_TOOLTIP = "This day isn't selectable right now";
  const isDisabled = !isDateInRange(current, minDate, maxDate);

  if (isDisabled) {
    return (
      <TooltipSystemV2
        title={unavailableDateTooltip || UNAVAILABLE_DATE_TOOLTIP}>
        <div className="ant-calendar-cell">
          <span className="ant-calendar-date">{current.date()}</span>
        </div>
      </TooltipSystemV2>
    );
  }

  if (!availableDateTooltip) {
    return (
      <div className="ant-calendar-cell">
        <span className="ant-calendar-date">{current.date()}</span>
      </div>
    );
  }

  return (
    <TooltipSystemV2 title={availableDateTooltip}>
      <div className="ant-calendar-cell">
        <span className="ant-calendar-date">{current.date()}</span>
      </div>
    </TooltipSystemV2>
  );
};
